export enum ECndnType {
  CREDIT = 1,
  DEBIT = 2,
  CREDIT_RETURN = 3,
}

export enum ECndnReason {
  RETURN_GOOD = 1,
  CREDIT_PRICE = 2,
  DEBIT_PRICE = 3,
}
